































import Vue from 'vue';
import { NavigationMenu } from '@/main/menu';
import { localizeLocal } from '../mixins/localization';

export default Vue.extend({
	name: 'SessionOver',
	components: {
		NavigationMenu,
	},
	computed: {
		LocalizeSessionOverHeaderText() : any {
			var language = localStorage.getItem("i18nextLng");
			if ((language === null) || (typeof language === "string" && language.length === 0)) {
				language = navigator.languages[0].split('-')[0];
			}
			language = (language == 'tw' ? 'zh' : language);
			if (sessionStorage.getItem('showUnexpectedError') === 'true') {
				return localizeLocal('UnexpectedErrorHeader', language as 'cs' | 'zh' | 'en');
			} else {
				return localizeLocal('SessionOverHeader', language as 'cs' | 'zh' | 'en');
			}
		},
		LocalizeSessionOverText() : any {
			var language = localStorage.getItem("i18nextLng");
			if ((language === null) || (typeof language === "string" && language.length === 0)) {
				language = navigator.languages[0].split('-')[0];
			}
			language = (language == 'tw' ? 'zh' : language);
			if (sessionStorage.getItem('showUnexpectedError') === 'true') {
				return localizeLocal('UnexpectedError', language as 'cs' | 'zh' | 'en');
			} else {
				return localizeLocal('SessionOver', language as 'cs' | 'zh' | 'en');
			}
		},
		LocalizeContinueText() : any {
			var language = localStorage.getItem("i18nextLng");
			if ((language === null) || (typeof language === "string" && language.length === 0)) {
				language = navigator.languages[0].split('-')[0];
			}
			language = (language == 'tw' ? 'zh' : language);
			return localizeLocal('ToContinue', language as 'cs' | 'zh' | 'en');
		},
		LocalizeInconvText() : any {
			var language = localStorage.getItem("i18nextLng");
			if ((language === null) || (typeof language === "string" && language.length === 0)) {
				language = navigator.languages[0].split('-')[0];
			}
			language = (language == 'tw' ? 'zh' : language);
			return localizeLocal('Inconvenience', language as 'cs' | 'zh' | 'en');
		},
	},
});
